import {Badge} from 'antd'
import classNames from 'classnames'
import React from 'react'
import {FaCrown} from 'react-icons/fa'
import {RiSignalTowerFill} from "react-icons/ri";

export const ChannelIcon = ({
    premium = 0,
    className,
    fill = null,
    strokeWidth = 1,
    ...props
}) => {
  if (premium !== 1) {
    return (
        <RiSignalTowerFill {...strokeWidth} className={fill} {...props}/>
    )
  } else {
    return (
      <Badge
        className={classNames(
          className,
          'flex items-center justify-center'
        )}
        count={ <FaCrown size={14} className="text-secondary z-3" /> }
        {...props}>
          <RiSignalTowerFill {...strokeWidth}/>
      </Badge>
    )
  }
}
